import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Bell, Settings, User } from "lucide-react";

import type { AccountMenuProps, AccountPrimaryMenuItem } from "../../types";

const AccountMenu = ({ currentUser, onItemClick }: AccountMenuProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const primaryMenuItems = useMemo((): AccountPrimaryMenuItem[] => {
    return [
      {
        key: "profile",
        icon: <User size={20} />,
        label: t("account.profileMenuItems.profile"),
        onClick: () => navigate(`/users/${currentUser.id}`),
      },
      {
        key: "account",
        icon: <Settings size={20} />,
        label: t("account.profileMenuItems.manageAccount"),
        onClick: () => navigate("/settings"),
      },
      {
        key: "notifications",
        icon: <Bell size={20} />,
        label: t("account.profileMenuItems.manageNotifications"),
        onClick: () => navigate("/settings?tab=notifications"),
      },
    ];
  }, [t, navigate, currentUser]);

  return (
    <div className="flex flex-col">
      {primaryMenuItems.map((item) => (
        <button
          key={item.key}
          type="button"
          className="account-popover-item flex items-center gap-200"
          onClick={() => {
            item.onClick();
            onItemClick();
          }}
        >
          <span>{item.icon}</span>

          <span className="body-m-regular">{item.label}</span>
        </button>
      ))}
    </div>
  );
};

export default AccountMenu;
